import { QueryClient } from '@tanstack/react-query';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, staleTime: 30000, refetchOnWindowFocus: false },
      mutations: { retry: false },
    },
  });
}
